import JsonResponse from "csi/comm/JsonResponse";
import { ControllerSaveFunction } from "csi/middleware/common";
import { submitWriter } from "csi/service/writerService";
import { C8Node, cnl } from "csi/typings";
import xml from "csi/xml";
import Writer from "csi/xml/Writer";
import { CheckboxTreeNode } from "designSystem/components/checkbox/CheckboxTree";
import NotifyCollaboratorsStore from "./NotifyCollaboratorsStore";
import sessionConstants from "csi/sessionConstants";

/** Create and initialize NotifyCollaboratorsStore */
export const createNotifyCollaboratorsStore = async (
	writer: Writer, 
	latestRevisionNode: C8Node, 
	onSave?: ControllerSaveFunction,
): Promise<NotifyCollaboratorsStore> => {
	const store = new NotifyCollaboratorsStore(writer, latestRevisionNode, onSave);
	return store;
};

/** Notify Collaborators */
export async function notifyCollaborators(writer: Writer, latestRevisionNode: C8Node, onSave?: ControllerSaveFunction): Promise<JsonResponse> {
	const { isSupplierUser, userSupplierUrl } = sessionConstants;
	const isSupplier = (isSupplierUser || userSupplierUrl);
	let updateStatus = "LinkedBOMUpdateStatus:UpdatedByHost";

	if (isSupplier) {
		updateStatus = "LinkedBOMUpdateStatus:UpdatedBySource";
	}
	writer.callMethod("ProductSpec", "UpdateSourceBOMLinkedUpdateStatus")
		.addParameter("URL", xml.ATTR_REF, latestRevisionNode.$URL)
		.addParameter("LinkedBOMUpdateStatus", xml.ATTR_ENUM, updateStatus);

	return submitWriter(writer);
};